var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptySearch(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M464.86,303.39c-14.73,39.43-44.81,82.11-87.14,94.75-64,19.1-71.6,70.65-186.16,65.87A230.92,230.92,0,0,1,142,456.75,194.41,194.41,0,0,1,118.73,449C51.8,421.89,16.89,362.23,14,299.81c-3.82-82.11,53.46-121.24,90.69-144.15S186.79,44,299.44,47.77a224.06,224.06,0,0,1,50.92,7.44c37.91,10.26,76.44,32.95,98.84,66.12q2.52,3.75,4.82,7.64C484,179.82,484.93,249.63,464.86,303.39Z",
    style: {
      fill: "#64748B"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.86,303.39c-14.73,39.43-44.81,82.11-87.14,94.75-64,19.1-71.6,70.65-186.16,65.87A230.92,230.92,0,0,1,142,456.75,194.41,194.41,0,0,1,118.73,449C51.8,421.89,16.89,362.23,14,299.81c-3.82-82.11,53.46-121.24,90.69-144.15S186.79,44,299.44,47.77a224.06,224.06,0,0,1,50.92,7.44c37.91,10.26,76.44,32.95,98.84,66.12q2.52,3.75,4.82,7.64C484,179.82,484.93,249.63,464.86,303.39Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-8"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 13,
    y1: 425,
    x2: 475,
    y2: 425,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Cloud--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M439.27,54.45c0-.28,0-.55,0-.84a18.27,18.27,0,0,0-35.87-4.92,11.63,11.63,0,0,0-.08,23.13v.07h35.77a8.72,8.72,0,0,0,.14-17.44Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "430.64 68.25 419.83 53.61 409.02 68.25 413.24 68.25 413.24 75.46 426.42 75.46 426.42 68.25 430.64 68.25",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Gears--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.92,106.61H70.74a16.73,16.73,0,0,0-2.15-5.08l3.07-3.08a3.81,3.81,0,1,0-5.39-5.39l-3.11,3.11a17.28,17.28,0,0,0-5-2V89.59a3.82,3.82,0,0,0-7.63,0v4.55a16.6,16.6,0,0,0-4.88,2l-3.28-3.28a3.82,3.82,0,0,0-5.4,0h0a3.83,3.83,0,0,0,0,5.39l3.22,3.21a16.8,16.8,0,0,0-2.13,4.86H33.55a3.82,3.82,0,0,0-3.82,3.82h0a3.82,3.82,0,0,0,3.82,3.81h4.37a16.56,16.56,0,0,0,2,5.08L36.8,122.1a3.81,3.81,0,0,0,5.39,5.39l2.94-2.93a16.82,16.82,0,0,0,5.14,2.26V131a3.82,3.82,0,1,0,7.63,0v-4a16.64,16.64,0,0,0,5.29-2.12l2.87,2.87a3.81,3.81,0,0,0,5.39,0h0a3.82,3.82,0,0,0,0-5.4l-2.84-2.84a16.78,16.78,0,0,0,2.17-5.23h4.14a3.82,3.82,0,0,0,0-7.63Zm-20.54,13a9.13,9.13,0,1,1,9.13-9.12A9.12,9.12,0,0,1,54.38,119.64Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.14,68.37H96a16.73,16.73,0,0,0-2.15-5.08l3.08-3.08a3.81,3.81,0,1,0-5.4-5.39l-3.11,3.11a17,17,0,0,0-5-2V51.35a3.82,3.82,0,0,0-7.63,0V55.9a16.6,16.6,0,0,0-4.88,2l-3.28-3.28a3.81,3.81,0,0,0-5.39,0h0a3.81,3.81,0,0,0,0,5.39l3.21,3.21a16.8,16.8,0,0,0-2.13,4.86H58.77A3.82,3.82,0,0,0,55,71.89h0a3.82,3.82,0,0,0,3.82,3.81h4.37a16.81,16.81,0,0,0,2,5.08L62,83.86a3.81,3.81,0,1,0,5.4,5.39l2.94-2.93a16.66,16.66,0,0,0,5.13,2.26v4.14a3.82,3.82,0,1,0,7.63,0v-4a16.54,16.54,0,0,0,5.29-2.12l2.87,2.87a3.81,3.81,0,0,0,5.39,0h0a3.82,3.82,0,0,0,0-5.4l-2.84-2.84A16.78,16.78,0,0,0,96,76h4.14a3.82,3.82,0,0,0,0-7.63Zm-20.53,13a9.13,9.13,0,1,1,9.12-9.12A9.12,9.12,0,0,1,79.61,81.4Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Codes--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.67,215.18H55.82a3,3,0,0,1,3,3V261.9a5.39,5.39,0,0,1-5.39,5.39H21.09a5.39,5.39,0,0,1-5.39-5.39V218.15A3,3,0,0,1,18.67,215.18Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.67,215.18H55.82a3,3,0,0,1,3,3v2.29a0,0,0,0,1,0,0H15.71a0,0,0,0,1,0,0v-2.29A3,3,0,0,1,18.67,215.18Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.29,217.91a1.4,1.4,0,1,0-1.4,1.4A1.4,1.4,0,0,0,48.29,217.91Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.77,217.91a1.4,1.4,0,1,0-1.4,1.4A1.4,1.4,0,0,0,52.77,217.91Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.26,217.91a1.41,1.41,0,1,0-1.41,1.4A1.41,1.41,0,0,0,57.26,217.91Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "32.07 226.42 24.69 232.26 32.07 238.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "42.2 226.42 49.58 232.26 42.2 238.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.08,
    y1: 225.05,
    x2: 35.85,
    y2: 239.13,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46.21,
    y1: 245.8,
    x2: 54.36,
    y2: 245.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.12,
    y1: 245.8,
    x2: 44.72,
    y2: 245.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.21,
    y1: 245.8,
    x2: 31.79,
    y2: 245.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.65,
    y1: 245.8,
    x2: 23.73,
    y2: 245.8,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.6,
    y1: 250.61,
    x2: 54.36,
    y2: 250.61,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 25.85,
    y1: 250.61,
    x2: 47.27,
    y2: 250.61,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.65,
    y1: 250.61,
    x2: 23.3,
    y2: 250.61,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.15,
    y1: 255.43,
    x2: 54.36,
    y2: 255.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.58,
    y1: 255.43,
    x2: 35.18,
    y2: 255.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.65,
    y1: 255.43,
    x2: 22.88,
    y2: 255.43,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.81,
    y1: 260.25,
    x2: 54.36,
    y2: 260.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34.33,
    y1: 260.25,
    x2: 47.27,
    y2: 260.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.65,
    y1: 260.25,
    x2: 31.79,
    y2: 260.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.52,224.7H70.67a3,3,0,0,1,3,3v43.76a5.39,5.39,0,0,1-5.39,5.39H35.94a5.39,5.39,0,0,1-5.39-5.39V227.67A3,3,0,0,1,33.52,224.7Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.52,224.7H70.67a3,3,0,0,1,3,3V230a0,0,0,0,1,0,0H30.55a0,0,0,0,1,0,0v-2.29A3,3,0,0,1,33.52,224.7Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 61.74,
    cy: 227.43,
    r: 1.4,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.62,227.43a1.4,1.4,0,1,0-1.4,1.4A1.4,1.4,0,0,0,67.62,227.43Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.7,
    cy: 227.43,
    r: 1.4,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "46.92 235.94 39.53 241.78 46.92 247.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "57.05 235.94 64.43 241.78 57.05 247.62",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.93,
    y1: 234.57,
    x2: 50.69,
    y2: 248.65,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 3
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 61.05,
    y1: 255.32,
    x2: 69.21,
    y2: 255.32,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.97,
    y1: 255.32,
    x2: 59.57,
    y2: 255.32,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.06,
    y1: 255.32,
    x2: 46.63,
    y2: 255.32,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.49,
    y1: 255.32,
    x2: 38.58,
    y2: 255.32,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.45,
    y1: 260.14,
    x2: 69.21,
    y2: 260.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.7,
    y1: 260.14,
    x2: 62.11,
    y2: 260.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.49,
    y1: 260.14,
    x2: 38.15,
    y2: 260.14,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53,
    y1: 264.95,
    x2: 69.21,
    y2: 264.95,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.42,
    y1: 264.95,
    x2: 50.03,
    y2: 264.95,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.49,
    y1: 264.95,
    x2: 37.73,
    y2: 264.95,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 64.66,
    y1: 269.77,
    x2: 69.21,
    y2: 269.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 49.18,
    y1: 269.77,
    x2: 62.11,
    y2: 269.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.49,
    y1: 269.77,
    x2: 46.63,
    y2: 269.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Speedometer--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51,385.19a31.94,31.94,0,0,0-31.94,31.93H82.94A31.94,31.94,0,0,0,51,385.19Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.31,410.75,73,394a31.93,31.93,0,0,0-53.94,23.13H57.2Z",
    style: {
      fill: "#64748B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,398a19.16,19.16,0,0,0-19.16,19.16H70.16A19.16,19.16,0,0,0,51,398Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,408a9.12,9.12,0,0,0-9.12,9.12H60.12A9.12,9.12,0,0,0,51,408Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52.79 416.5 50.66 414.38 69.36 396.75 70.42 397.81 52.79 416.5",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Charts--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M450.42,315.43a13,13,0,1,0,13,13A13,13,0,0,0,450.42,315.43Zm0,20.84a7.82,7.82,0,1,1,7.82-7.81A7.81,7.81,0,0,1,450.42,336.27Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.6,339.32l-3.08-4.22a7.73,7.73,0,0,1-4.1,1.17,7.82,7.82,0,0,1,0-15.63,7.71,7.71,0,0,1,4,1.09l2.72-4.44a13,13,0,1,0,.5,22Z",
    style: {
      fill: "#64748B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.42,351a13,13,0,1,0,13,13A13,13,0,0,0,450.42,351Zm0,20.83a7.81,7.81,0,1,1,7.82-7.81A7.81,7.81,0,0,1,450.42,371.86Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.24,364.05a7.81,7.81,0,0,1-11.75,6.74l-2.19,4.75a13,13,0,0,0,19.14-11.49,12.7,12.7,0,0,0-.22-2.33L458,362A8,8,0,0,1,458.24,364.05Z",
    style: {
      fill: "#64748B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 435.33,
    y: 394.15,
    width: 4.67,
    height: 12.19,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 444.33,
    y: 395,
    width: 4.67,
    height: 11.33,
    style: {
      fill: "#64748B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.33,
    y: 389.37,
    width: 4.67,
    height: 16.96,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 462.33,
    y: 383.23,
    width: 4.67,
    height: 23.1,
    style: {
      fill: "#64748B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Files--inject-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "447.91 168.5 447.91 166.2 438 166.2 438 168.5 438 170.05 438 182.34 458.86 182.34 458.86 168.5 447.91 168.5",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.71 168.5 473.71 166.2 463.8 166.2 463.8 168.5 463.8 170.05 463.8 182.34 484.67 182.34 484.67 168.5 473.71 168.5",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.91 191.56 447.91 189.25 438 189.25 438 191.56 438 193.11 438 205.4 458.86 205.4 458.86 191.56 447.91 191.56",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.71 191.56 473.71 189.25 463.8 189.25 463.8 191.56 463.8 193.11 463.8 205.4 484.67 205.4 484.67 191.56 473.71 191.56",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.91 214.62 447.91 212.31 438 212.31 438 214.62 438 216.17 438 228.46 458.86 228.46 458.86 214.62 447.91 214.62",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.71 214.62 473.71 212.31 463.8 212.31 463.8 214.62 463.8 216.17 463.8 228.46 484.67 228.46 484.67 214.62 473.71 214.62",
    style: {
      fill: "#64748B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.91 237.68 447.91 235.37 438 235.37 438 237.68 438 239.23 438 251.52 458.86 251.52 458.86 237.68 447.91 237.68",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.71 237.68 473.71 235.37 463.8 235.37 463.8 237.68 463.8 239.23 463.8 251.52 484.67 251.52 484.67 237.68 473.71 237.68",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "447.91 260.74 447.91 258.43 438 258.43 438 260.74 438 262.29 438 274.57 458.86 274.57 458.86 260.74 447.91 260.74",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "473.71 260.74 473.71 258.43 463.8 258.43 463.8 260.74 463.8 262.29 463.8 274.57 484.67 274.57 484.67 260.74 473.71 260.74",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stars--inject-8"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "324.2 87.58 326.51 94.7 333.99 94.7 327.94 99.09 330.25 106.21 324.2 101.81 318.15 106.21 320.46 99.09 314.41 94.7 321.89 94.7 324.2 87.58",
    style: {
      fill: "#64748B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "348.89 87.58 351.2 94.7 358.68 94.7 352.63 99.09 354.94 106.21 348.89 101.81 342.84 106.21 345.15 99.09 339.1 94.7 346.58 94.7 348.89 87.58",
    style: {
      fill: "#64748B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.58 87.58 375.89 94.7 383.37 94.7 377.32 99.09 379.63 106.21 373.58 101.81 367.53 106.21 369.84 99.09 363.79 94.7 371.27 94.7 373.58 87.58",
    style: {
      fill: "#64748B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.27 87.58 400.58 94.7 408.06 94.7 402.01 99.09 404.32 106.21 398.27 101.81 392.21 106.21 394.53 99.09 388.48 94.7 395.95 94.7 398.27 87.58",
    style: {
      fill: "#64748B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "422.95 87.58 425.27 94.7 432.75 94.7 426.69 99.09 429.01 106.21 422.95 101.81 416.9 106.21 419.21 99.09 413.16 94.7 420.64 94.7 422.95 87.58",
    style: {
      fill: "#64748B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-8"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 251.5,
    cy: 436.5,
    rx: 164.5,
    ry: 5.5,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.27,
    y: 129,
    width: 336.21,
    height: 252.16,
    rx: 8.48,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.2,400.6V372.2H209.54v28.4a41.17,41.17,0,0,1-8.88,25.54L197,430.76H305.75l-3.67-4.62A41.17,41.17,0,0,1,293.2,400.6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 209.54,
    y: 372.2,
    width: 83.65,
    height: 22.8,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197,
    y: 430.76,
    width: 108.77,
    height: 5.07,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.27,342H419.48a0,0,0,0,1,0,0v30.71a8.48,8.48,0,0,1-8.48,8.48H91.75a8.48,8.48,0,0,1-8.48-8.48V342A0,0,0,0,1,83.27,342Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.18,
    y: 144.69,
    width: 302.39,
    height: 178.15,
    style: {
      fill: "#64748B",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M154.2,204.18s-1.69,3-4,1.14-8-5.72-11.58-4.39-4.85,5.73-3.16,7.06,2.1,2.86-.64,4.77-1.47,4.39.85,5,4-.38,3.79,1,0,2.09-3.58,3.62-3.37,2.86,1.26,1.53,5.27-4.39,7.37-6.49,11.17,2.1,13.7,6.49,2.32,8.77,2.32,12.21,4.84,3.81,5.89,6.87,3,5.91,3.37,5.15-.21-1.72-.21-2.67,3.16,2.09,3.59,4.19,4,4.58,5.89,4.58a10.23,10.23,0,0,1,5.9,1.91c1.27,1.14,4.22,3.82,5.27,3.82s1.05-.58,1.69,0,.63,2.29.21,4-2.11,2.29.21,5.73S198,274.77,198,278s-3.58,15.07-3.58,18.51,3.37,7.44,4.64,7.06.21-2.29.21-4,2.11-3.05,2.11-4.58,1.47-3.24,2.73-4.39,3.37-1.9,4.64-3.81,3.37-3.63,4.21-5a46,46,0,0,1,2.95-4c1.9-2.48,1.9-4.39,3-6.11s1.27-5.15-1.26-5.91-6.11-1.91-7-3.05-5.47-3.06-6.32-3.25-2.1-1.71-3.79-1.9a24.08,24.08,0,0,0-3.37-.19,23.2,23.2,0,0,0-3.79.76h-2.74l-2.32-1.53s.85-2.48-.84-2.86a12.94,12.94,0,0,0-2.53-.38s1.27-2.29,0-2.48-3.58,1.33-4.21,1.33-2.74-3.24-1.69-4.77,1.9-2.86,4-3.24,4-1.91,5.26,0,4.22,5.34,4.22,3.24-1.48-3.24-1.27-4.57,2.95-.77,2.95-3.44,1.06-4.2,2.32-4.77,4.85-.19,4.63-2.86-1.89-.19-3.16-1.15,1.27-3.24,3.8-3.24,4.63-.57,4-2.48-3.37-3.05-4.64-5.53-2.52.19-4-1.15-4-3-4.21-.57,1.26,5.53.63,7.06-3.58,3.05-4.42,1.34,0-2.48-2.32-3.82-4.85-2.48-5.06-5,1.48-4.2,3.58-5.72,4.85-2.87,4.64-5.35-1.9-3.43-2.32-1.52a1.9,1.9,0,0,1-3.58.38c-.84-1.53-2.74-2.29-2.74-.95s-.42,2.67-2.11,2.67-4.21-1.34-5.26-1.15-1.48,1.15-2.74,1.15-3.37.38-3.79-1-3.16-1.71-5.06-2.1a21,21,0,0,0-5.27-.57A10.24,10.24,0,0,1,154.2,204.18Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.44,251.68s-1.06,0-4.43-1.52-6.11-1-4.42-.2,4.84,1.91,4.84,1.91-3.58-.19-.42.77S201.39,252.83,198.44,251.68Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M239.94,241.76a22.49,22.49,0,0,1-1.69,4.2c-.63.76-3.16,1.91-3.79,4a9.4,9.4,0,0,0,1.26,7.06c1.27,1.91,2.32,2.1,5.27,2.87s7.37,0,9.06.19-.63,3.24-.63,4.19,4.21,2.87,4.42,4.58-1.68,5.35,0,7.63,2.32,3.82,2.32,5.16-.63,3.43,3.58,4,7.16-1.14,7.8-3.62.63-5,2.52-5.92a5,5,0,0,0,2.53-5.34c-.42-2.1-.84-5.15.84-6.3s5.06-3.24,5.27-5.34-1.68-.19-4.42-2.1-5.69-7.63-6.32-9.15-.63-2.87,1.68,0,2.95,8.58,6.53,8.58,8.64-4,8.85-5.91-2.1-.77-4.63-2.48-4.22-5.92-1.06-4.77,7.38,5,9.06,5,6.74-1.72,6.95,1.33-1,8,1.9,8.21,2.11-3.06,2.95-4.2,5.48-4.58,6.53-3.82.42,3.82,3.16,4,3.79.76,2.95,1.72-1.05,4.19,0,3.81-.21-3.62,1.69-2.67,4.84-.95,4.84-1.91-3.58-2.09-2.53-3.81,4.43-2.1,6.74-2.29,4.43-3.44,3.38-5.34-1.9-3.25-.64-3.63-.84-1.52-.84-2.1,1.9-2.1,3.16-.95.63,2.67,1.69,3.82,2.31.95,2.31-.58a21.38,21.38,0,0,0-.63-4s1.9-1.53,2.95-1.34,4-3.24,4.85-5.72.21-4-1.06-4-3.37-2.67-1.05-4.2,5.9-2.67,7.58-2.1,3-.19,4-1.71,3.58-1.53,4.84-1.53,2.53-2.86,2.74-1.33-4.42,4.77-5.27,6.86-1.68,5.35.21,5.54,2.74-3.06,3.16-4.58.64-4.2,1.9-4.39,1.9.57,3.79-.76,4.43-1.53,4.85-3.44,1.26-6.1-1.06-8.2-3.79-.76-6.32,0-5.47-3.63-5.47-3.63a33.93,33.93,0,0,0-4.85-.38c-2.53,0-3.58-2.67-5.27-2.86s-1.47,2.29-3.16,2.86-2.1.19-3.37.19-2.52.38-2.95-.76-1.47-3.05-2.94-3.24-3.16.57-4,.57-3.79-1-4.63-1-4,.58-4,.58,4.63-5.92,3.79-7.44-4.22-1.91-6.11-1.34-3.79.38-5.06,1.15-4.84,1.33-5.9,2.86-.84,2.1-2.31,3.05-1.48,2.48-1.27,4-1.89-1.72-3.37-.77-2.32,1.53-1.9,2.86,2.11,2.87,1.69,4.2-3.58,2.48-3.58.57,1.68-9.34-.63-9.15-2.95,2.86-2.32,4.77,1.05,2.67-.21,2.67-3-2.48-4.21-1.15-4.85,1.53-6.54,1.72-4.21,2.67-5.47,3.62-1.69,2.49-4,2.68-3.79-4-2.73-4,4.84,1.91,4.84-.38-5.9-4.58-8.85-5-7.58.76-8.42,3.24-.43,6.11-3.16,8.59-4.43,5.34-2.32,5.34,3.37-2.86,3.58-.57a1.83,1.83,0,0,0,3.37.95c.63-1.14.63-3.43.63-5.53s3.79-5.92,4.43-4.2-2.11,4.39-2.11,6.1,3.16.39,4.85.39,2.94,1.14.21,1.52-2.95.38-3.59,2.1.22,2.86-2.31,3.44-8.64-.39-9.9,1.71-1.9,3.25-3.16,3.63-3.8.19-3.38,1.91,1.69.76,1.06,2.48-2.74-1-3.58.38,1.26,7.44,3.16,5.72a13.55,13.55,0,0,0,2.95-4.39s1.89-.19,2.31-1,3.16-2.48,4,0,2.1,1.91,2.1,3.05-2.1,2.48-.21,1.72,3-.57,2.32-2.86-3-5-1.69-4.39a9,9,0,0,1,3.38,3.81c.63,1.34,3.79,5.16,4.21,3.63s-.42-4.2.21-4.2,1.9-1.52,2.32-3,5.68.19,6.74,1.53S270.27,236,268,236s-5.27,1.52-3.37,2.86,4.84-1.53,5.26.57-.63,4-2.31,4-3.8-.77-5.27-.77-1.69,1.91-4.42,1.34-3.38-2.86-5.48-4.2-4-.38-5.69.19S241,240.23,239.94,241.76Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M291.55,187.77a9.53,9.53,0,0,1-2.74,3.43c-1.68,1.15-6.11,4.77-6.11,6.87s1.9,4-1.05,3.24.63-8.39,2.74-10.3,2.11-.95,3.79-1.91S291.34,186.24,291.55,187.77Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M323.36,260.84s-2.52,0-3.37,1.91,2.53,3.62,3.58,2.29.64-3.06,1.06-4S324.63,259.69,323.36,260.84Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M316,264.46s-1.47-7-2.11-5a5.83,5.83,0,0,0,0,3.63s-5.68-4.2-5.05-1.72,5.05,4,7.16,5.54,2.32,1.33,5.27,2.28,4.84-.57,2.53-1-6.11-2.29-7-2.67A1.34,1.34,0,0,1,316,264.46Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M341.06,265.42s-9.48-3.24-8.43-1.34,4.43,1.34,5.06,2.29,1.05,2.86,2.53,2.86,2.74-.57,3.58.39,2.74,2.29,3.37,1.33-.84-2.1-1.9-3.43S341.06,265.42,341.06,265.42Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M341.06,271.33s-.21,2.87-2.32,2.67-.42-3.05-3.16-2.67-2.31,2.29-3.79,2.29-4,.77-4.21,1.53-1.9,1.53-3.16,1.53-2.53,2.48-2.11,3.81,1.26,3.05,1.26,4.39,0,2.48,2.32,1.91,5.9-3.25,8.64-2.29,5.06,4.2,6.74,5.15,2.74,1.91,4.21-.57,3.59-5,3.59-8-2.32-3.24-4.22-6.1S341.69,269.81,341.06,271.33Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M361.5,291.56s.63.38-1.48,1.33-2.53,2.29-1,3.06,3.37-2.1,4-3.06S364.23,289.65,361.5,291.56Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M278.28,272.29s-1-.19-2.53,1.14-.21,2.1-.63,3.82,0,3.62,1.69,2.48,3.37-5.15,3.37-6.68S279.75,270.19,278.28,272.29Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M261.64,178.61s.21.76-2.53.19-3.58.95-4.21,1.14-3.8-1.71-3.59.58,2.95,5.34,4,3.62.21,0-1.06,1.72,1.48,4,2.74,2.48,1.27-6.68,1.9-5,1.68,4.77,3,3.43-2.11-5-2.11-6.1.63.76,2.32-.38S263.53,178.42,261.64,178.61Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M316.2,183.38s.84-2.67-1.26-2.48-4.43,1.72-2.53,3S316.2,183.38,316.2,183.38Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M312.41,178.23c-.42-.77-2.11-6.11-3.37-4.58s.63,5.53.63,5.53-.84,1.53,1.05,1.72S312.41,178.23,312.41,178.23Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M213,170.79c-1,.18-5.26-2.67-7.58-.77s-2.53,3.06-3.79,5.73,0,4.39-.43,5,.22-.38-2.31,1.14-3,1-1.48,3.06-.63,2.09,1.69,4,3.16-1.52,5.69.77,1.26,5.15,3,10.87,2.52,14.88,3.79,16.41,3.37,1.91,4.42-.57,3-6.87,6.11-8.4,7.59-3.43,7.59-5.53-1.69-3.05-1.06-4.58,2.11-.38,2.11-2.86v-5.15c0-2.1-.42-7.06,0-7.64a15,15,0,0,0,1.89-3.62c0-.57,1.48-2.29,1.9-2.86a5.81,5.81,0,0,0,.84-2.48c0-.58,1.06-1.91-.84-1.15s-1.9,2.48-3.37,3.44-3.37,1.52-3.37-.38,2.11-4.2,0-4.39a12.8,12.8,0,0,0-4.42.57s2.1-1,2.73-1.34,2.74-.57,3.37-1.14a3.88,3.88,0,0,0,.85-1.91,4.14,4.14,0,0,0-1.9-1.14c-1.26-.39-1.26-1.72-2.53-2.1a35.15,35.15,0,0,0-5-.57s-4,1.14-4.85,1.52A24.56,24.56,0,0,0,213.6,166s-.63,1.9,0,2.67S215.08,170.41,213,170.79Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M199.7,172.31s-1,2.1-1.69,3.44a30.36,30.36,0,0,1-2.52,4.19c-1.06,1.53-1.69,2.29-1.69,2.87s1,1.71-.63,3.05a27.27,27.27,0,0,1-4,2.48,1.83,1.83,0,0,1-2.32,1.14c-1.69-.57-.63-3.43,0-4.38s0-3.63-1.26-3.06-2.11,1.72-3.38.19-1.68-4.57-1.68-6.1,0-3.63,1.26-2.86,5.27,3,5.9,2.67-.84-1.91-1.68-3.05-2.74-2.48-.42-3.63,4.84-1.34,6.53-2.29,2.73-1.72,4.84-1.14,4,0,4.64,1.52a9.73,9.73,0,0,1,.63,3.25Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M187.69,191.2a15.29,15.29,0,0,1-2.53-1.14c-2.31-1.15-3.58-5.35-4.21-2.87s2.53,5.35,4,6.11,7.59.76,6.74-1.34S187.69,191.2,187.69,191.2Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M196.12,200a24.93,24.93,0,0,1-5.48-2.67c-1.47-1.15-4-3.06-5-1.53s-.43,6.11,1.26,7.06,4.21-1.15,5.69.76,3.37,3.82,3,5.15-1.27,2.48.42,4.39,4,2.1,4-.38-2.11-4-.42-4.2,3.37,1.72,2.53-.95a13.14,13.14,0,0,0-2.74-4.58A25.24,25.24,0,0,0,196.12,200Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M176.74,203.22a3.06,3.06,0,0,1-2.11-3.05c0-2.48-2.11-5.53-2.74-3.82s-2.11,2.29-3.79,1-3.37-4.2-5.06-2.87-6.74,4.2-2.52,5.54,5.68-1.34,6.1-.77-.42.39,0,2.68,2.74,3.43,4.64,3.43,2.32-1.91,3.16-1.14S177.58,205.89,176.74,203.22Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M257.57,361.56a6.2,6.2,0,1,0-6.2,6.2A6.2,6.2,0,0,0,257.57,361.56Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.38,169.6H120.9a7.56,7.56,0,0,1-7.57-7.56h0a7.57,7.57,0,0,1,7.57-7.56H384.38a7.57,7.57,0,0,1,7.56,7.56h0A7.56,7.56,0,0,1,384.38,169.6Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.38,169.6H371.23V154.48h13.15a7.57,7.57,0,0,1,7.56,7.56h0A7.56,7.56,0,0,1,384.38,169.6Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.45,156.4a4.34,4.34,0,1,0,.2,6.14A4.33,4.33,0,0,0,381.45,156.4ZM381,162a3.49,3.49,0,1,1-.16-4.93A3.5,3.5,0,0,1,381,162Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.71,164.11A.7.7,0,0,0,384,164l-1.57-1.47a.43.43,0,0,0-.6,0l-.14.15a.41.41,0,0,0,0,.59l1.55,1.46a.72.72,0,0,0,.19.77l2.66,2.61a.94.94,0,0,0,1.32,0h0a.94.94,0,0,0,0-1.33Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--magnifying-glass--inject-8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M390.41,314.89a11.17,11.17,0,0,1-10.94-8.78l-2.36-10.93a13.16,13.16,0,0,0-12.9-10.35h0a13.17,13.17,0,0,0-12.66,9.42l-1.6,5.42a10.06,10.06,0,0,1-19.09.56l-5.28-14.63a22.45,22.45,0,0,0-39.06-5.73L276.43,293.4a10.73,10.73,0,0,1-8.61,4.31h0a10.67,10.67,0,0,1-10.71-10.63v-9.59H245v9.59a10.73,10.73,0,0,1-19.32,6.32l-10.09-13.53a22.45,22.45,0,0,0-39.06,5.73l-5.28,14.63a10.07,10.07,0,0,1-19.1-.56l-1.59-5.42a13.22,13.22,0,0,0-25.56.93l-2.36,10.93a11.18,11.18,0,0,1-10.94,8.78h-11.5v7.95H401.91v-7.95Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.76,51.85a50.52,50.52,0,1,1-50.83,50.21A50.52,50.52,0,0,1,252.76,51.85Zm-.56,91.06a40.55,40.55,0,1,0-40.29-40.79A40.53,40.53,0,0,0,252.2,142.91Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.78,49A50.52,50.52,0,1,1,202,99.16,50.53,50.53,0,0,1,252.78,49ZM252.22,140a40.54,40.54,0,1,0-40.29-40.79A40.54,40.54,0,0,0,252.22,140Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 245.57,
    y: 151.11,
    width: 12.23,
    height: 45.05,
    rx: 2.88,
    transform: "translate(502.28 348.83) rotate(-179.65)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.14 277.98 244.95 277.98 243.43 263.29 258.66 263.29 257.14 277.98",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.06,215.45l-11,16.1v23.76a1.37,1.37,0,0,0,1.37,1.37h0a1.38,1.38,0,0,0,1.38-1.37v-6.88l8.24-3.14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.48,215.45l11,16.1v23.76a1.38,1.38,0,0,1-1.38,1.37h0a1.37,1.37,0,0,1-1.37-1.37v-6.88l-8.25-3.14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247,180.07h9.24a6.3,6.3,0,0,1,6.3,6.3V264a4.93,4.93,0,0,1-4.93,4.93h-12a4.93,4.93,0,0,1-4.93-4.93V186.38A6.3,6.3,0,0,1,247,180.07Z",
    transform: "translate(501.94 450.45) rotate(-179.66)",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.52,256.72l0,5.71a6.37,6.37,0,0,0,6.34,6.42l9.07.06a6.39,6.39,0,0,0,6.43-6.35l0-5.84Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.49,256.68h0a2,2,0,0,1-2-2V217a2,2,0,0,1,2-2h0a2,2,0,0,1,2,2v37.7A2,2,0,0,1,251.49,256.68Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.35,96.09v.34H224V96c0-1.14-.44-1.8-1.44-1.8s-1.45.66-1.45,1.78c0,2.82,4.24,3.09,4.24,6.64,0,1.91-.92,3.15-2.85,3.15s-2.83-1.24-2.83-3.15v-.72H221v.79c0,1.14.47,1.8,1.48,1.8s1.47-.66,1.47-1.8c0-2.81-4.21-3.08-4.21-6.62,0-2,.9-3.15,2.79-3.15S225.35,94.18,225.35,96.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.07,98.64V99.9H228v4.49h3.78v1.28h-5.18V93.06h5.18v1.28H228v4.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.49,103.13l-.49,2.54h-1.29l2.41-12.61h2l2.41,12.61h-1.41l-.48-2.54Zm.18-1.21h2.81l-1.42-7.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.47,93.06c2,0,2.81,1,2.81,2.88v1c0,1.39-.48,2.25-1.56,2.59,1.15.34,1.58,1.28,1.58,2.63v2a3.25,3.25,0,0,0,.25,1.52h-1.42a3.36,3.36,0,0,1-.23-1.53v-2c0-1.43-.67-1.88-1.84-1.88h-1v5.39h-1.41V93.06ZM243.11,99c1.12,0,1.79-.36,1.79-1.72V96.07c0-1.13-.42-1.73-1.46-1.73h-1.37V99Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.32,96.11v1.13H252V96c0-1.13-.45-1.81-1.48-1.81S249,94.9,249,96v6.67c0,1.13.47,1.81,1.48,1.81s1.48-.68,1.48-1.81v-1.64h1.33v1.56c0,1.91-.9,3.17-2.85,3.17s-2.82-1.26-2.82-3.17V96.11c0-1.91.9-3.17,2.82-3.17S253.32,94.2,253.32,96.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,100v5.68h-1.4V93.06H256v5.67h3.1V93.06h1.4v12.61h-1.4V100Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.34,93.06v12.61h-1.4V93.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266,105.67h-1.26V93.06h1.78l2.92,9.11V93.06h1.24v12.61h-1.46L266,95.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.71,96.11v1.08h-1.33V96c0-1.13-.45-1.81-1.48-1.81s-1.48.68-1.48,1.81v6.67c0,1.13.47,1.81,1.48,1.81s1.48-.68,1.48-1.81v-2.52h-1.3V98.91h2.63v3.71c0,1.91-.9,3.17-2.85,3.17s-2.82-1.26-2.82-3.17V96.11c0-1.91.9-3.17,2.82-3.17S277.71,94.2,277.71,96.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.21,103.92v1.75h-1.35v-1.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283,103.92v1.75h-1.35v-1.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.79,103.92v1.75h-1.35v-1.75Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-8"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 395.5,
    cy: 467,
    rx: 38.5,
    ry: 7,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.06,350l1.83,2.75a33.24,33.24,0,0,0,.73,4.58c.37.91,1.29,2.38.92,3.48s-1.65,2.38-1.65.18a11.39,11.39,0,0,0-.18-2.75l-3.85-2Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.86,358.93s.8,2.94,1.2,4.14,2,2.13,3.07,2.54,1.6.06,1.2-.61a10.18,10.18,0,0,0-2.13-1.8l-3.34-6.14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.72,302.28l-8.94-2.86-3.93,17.88s-5.72,12.87-6.44,18.23a120.29,120.29,0,0,1-2.72,12.72l-1.95,3.41-1.46,6.41L344,363.2a13.63,13.63,0,0,0,3.11.55c1.28,0,1.47-.36,1.28-.91s-1.1-.92-1.1-.92,2.2-.18,2.57-.92-2.2-1.65-2.2-1.65,2.2-.36,2-1.1-2.49-.59-2.49-.59a20,20,0,0,0,1.57-8c1.93-3.31,12.21-21.12,12.21-23.06C361,324.45,366.72,302.28,366.72,302.28Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.05,361.88a9.82,9.82,0,0,1-1.82-.58,10.56,10.56,0,0,1-2-2.39",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "347.69 359.35 345.89 359.24 344.49 357.91",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "414.64 300.85 417.86 323.74 407.84 345.55 403.55 340.9 408.56 321.59 404.27 302.28 414.64 300.85",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "379.6 272.22 361.55 280.64 369.07 318.84 400.35 319.74 409.76 279.64 390.73 271.92 379.6 272.22",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.27,260.75s-.43,2.42,2.38,6.36c.69,1,1.06.53,1.06.53L378.65,274a8.63,8.63,0,0,0,7.83,4.24c3.33,0,5-4.9,5-4.9-.23.08-.9-6.77-.9-6.77l-9-14.58-6.63,1.32s-2.94-.77-2.41,3.74S376.27,260.75,376.27,260.75Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.49,248.41s-2.6-8.88-9-11.8-13.26,1.33-15.65,6.9,2.39,17.24,2.39,17.24,2.91,6.63,6.36,8.22,6.82-1.05,10-5.29S398.76,252.65,398.49,248.41Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 400.53,
    cy: 246.96,
    rx: 9.41,
    ry: 8.75,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.21,365.51s3.18,31,3.18,39.78.8,23.34,1.33,30.23,2.38,17.24,2.38,17.24-1.32-.53-1.85,1.86-.8,2.91-3.18,3.71-4.25,2.39-3.19,3.71,6.9,1.86,11.14,2.92,4.78-.27,4.78-3.18v-8.49s2.91-45.08,2.91-46.68,1.06-39.51,1.06-39.51Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.07,368.67l10.44,7.75c.15-5.39.26-9.32.26-9.32l-12-1Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372,465c4.25,1.06,4.78-.27,4.78-3.18v-8.49c-3.45-1.86-5,3.71-6.1,3.18s-1.6-3.71-1.6-3.71-1.32-.53-1.85,1.86-.8,2.91-3.18,3.71-4.25,2.39-3.19,3.71S367.78,463.9,372,465Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.2,366.3s3.18,26,3.45,31.3,16.44,53.57,16.44,53.57,1.59,8,2.39,10.34,1.32,2.92,2.91,2.92,6.63,0,7.17-2.12-2.66-8.49-3.45-10.61-2.12-4.24-2.12-5.3-4-26.79-5.84-35.54-4.51-13.26-4.51-13.26L410,361.53Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.24,366.33l-9.43-2.58L388.2,366.3s.53,4.32,1.17,9.79l19.7-8.6Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M413.39,464.43c1.6,0,6.63,0,7.17-2.12s-2.66-8.49-3.45-10.61c-.67-1.79-1.72-3.58-2-4.73-6.76-2.38-7,4.2-7,4.2s1.59,8,2.39,10.34S411.8,464.43,413.39,464.43Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.25,458.06c-3.39.28-4.49,1.94-4.76,3.5.79,2.34,1.32,2.87,2.9,2.87s6.63,0,7.17-2.12a3.68,3.68,0,0,0-5.31-4.25Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.3,274.25s2.76,25.48,1.7,28.93-11.14,15.91-11.14,15.91l.27,8.23a28.08,28.08,0,0,0-5,12.46c-1.33,8-2.92,26.79-2.92,26.79s10.08,2.12,16.18,3.18,9,.26,9,.26l2.65-8.75,1.32,8.75a98,98,0,0,0,13.79,1.07c7.17,0,12.47-5.84,12.47-5.84S410,348,410,346.15s-6.1-22-6.1-22l.25-7.2a32.72,32.72,0,0,0-4.2-5.25c-3.18-3.45-5.87-12.48-5.87-12.48l2.28-25.42-2-1-3.18,25.89-11.67-.26-2.72-25.26Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 375.89,
    y1: 330.03,
    x2: 399.91,
    y2: 326.14,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 373.94,
    y1: 326.79,
    x2: 381.3,
    y2: 325.49,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385.02,
    y1: 361.26,
    x2: 385.02,
    y2: 355.43,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 379.98,
    y1: 354.9,
    x2: 389.79,
    y2: 354.9,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "361.55 280.64 354.21 300.49 368.15 304.43",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "409.76 279.64 418.21 301.92 404.27 304.43",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptySearch);
export default __webpack_public_path__ + "static/media/empty-search.1e9a7388b479c2a2be6c3734a80b5d54.svg";
export { ForwardRef as ReactComponent };